import { useState, useEffect } from "react";
import ErrorPage from "../pages/ErrorPage";

const MemberDisabledMessage = ({errorMessage}) => {
    const [isSafari, setIsSafari] = useState(false);

    useEffect(() => {
        let navString = navigator.userAgent.toLowerCase();
        setIsSafari(navString.indexOf('safari') > -1 && navString.indexOf('chrome') === -1);
    },[]);

    useEffect(() => {
        console.log('errorMessage', errorMessage);
    }, [errorMessage]);

    return (
        <>
            {typeof errorMessage === 'string' && errorMessage.indexOf('Failed to fetch') > -1 && (
                <ErrorPage title="Estamos enfrentando uma instabilidade no acesso ao site do Intelbras Pontua.">
                    <div>
                        <p>Nossa equipe já está ciente e trabalhando para resolver a situação.</p>
                        <p>Agradecemos sua compreensão e seguimos à disposição para qualquer dúvida.</p>
                    </div>
                </ErrorPage>
            )}
            {(!errorMessage || errorMessage.indexOf('Failed to fetch') === -1) && (
                <>
                    {!isSafari && (
                        <ErrorPage title="Parece que você não tem acesso ao Intelbras Pontua">
                            <div>
                                <p>Parceiro, o Intelbras Pontua é um benefício exclusivo para Parceiros credenciados no Programa de Canais Intelbras (PCI).</p>
                                <p>Se você é o gestor da conta, revise seu cargo para "Proprietário/a" ou "Sócio" no <a href="https://extranet.intelbras.com.br/gestao-canais/colaboradores/" target="_blank" rel="noreferrer">Portal de relacionamento</a>. Se você é Vendedor de um Distribuidor, solicite ao gestor da conta a revisão do seu cargo para cargo "Vendedor/a" no Portal de relacionamento. O acesso será liberado no prazo de 24 horas.</p>
                                <p>Se o problema persistir ou se tiver alguma dúvida, não hesite em entrar em contato através do e-mail <a href="mailto:intelbraspontua@intelbras.com.br">intelbraspontua@intelbras.com.br</a>.</p>
                            </div>
                        </ErrorPage>
                    )}
                    {isSafari && (
                        <ErrorPage title="Problemas de conexão com o navegador Safari">
                            <div>
                                <p>Identificamos que o navegador Safari está apresentando instabilidades de conexão.</p>
                                <p>Recomendamos, temporariamente, que utilize o navegador <strong style={{"color": "var(--color-brand)"}}>Google Chrome</strong> para acessar o Intelbras Pontua.</p>
                                <p>Se o problema persistir ou se tiver alguma dúvida, não hesite em entrar em contato através do e-mail <a href="mailto:intelbraspontua@intelbras.com.br">intelbraspontua@intelbras.com.br</a>.</p>
                            </div>
                        </ErrorPage>
                    )}
                </>    
            )}
            

        </>
    )
};

export default MemberDisabledMessage;